import React from "react";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import { SingleInputField } from "../../../components";
import { adminLoginData } from "../../../assets/lib/login";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#fff",
    fontFamily: "Montserrat",
  },
  loginBox: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "12px",
    border: "1px solid #ccc",
    boxShadow: "0 0 15px rgba(0,0,0,0.05)",
    width: "100%",
    maxWidth: "400px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  title: {
    margin: 0,
    fontSize: "24px",
    fontWeight: "bold",
    textAlign: "center",
  },
  subtitle: {
    margin: 0,
    fontSize: "16px",
    textAlign: "center",
    color: "#555",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
});

const Layout = ({
  loginState,
  errorFields,
  getLoginInput,
  handleLogin,
  loginFailedText,
  submitLoading,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.loginBox}>
        <h1 className={classes.title}>Campus Portal</h1>
        <h2 className={classes.subtitle}>
          Sign in with your campus credentials
        </h2>

        {!!loginFailedText && (
          <p style={{ color: "red", textAlign: "center" }}>
            {loginFailedText}
          </p>
        )}

        <div className={classes.inputContainer}>
          <SingleInputField
            content={adminLoginData.email}
            value={loginState.email}
            getInputData={getLoginInput}
            errorFields={errorFields}
          />

          <SingleInputField
            content={adminLoginData.password}
            value={loginState.password}
            getInputData={getLoginInput}
            errorFields={errorFields}
          />
        </div>

        <Button
          variant="contained"
          sx={{
            bgcolor: "#000",
            color: "#fff",
            fontWeight: "bold",
            py: 1,
          }}
          onClick={handleLogin}
          disabled={submitLoading}
        >
          {submitLoading ? "Logging in..." : "Login"}
        </Button>
      </div>
    </div>
  );
};

export default Layout;
